module.exports = __webpack_public_path__ + "static/media/collage-elephant-small.d281ad57.gif";